import React, { useRef, useEffect, useState } from 'react'
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarafiyat } from '../../../../../assets/zarafiyat.svg'
import QrSvg from '@wojtekmaj/react-qr-svg'
import tshirtlogo from '../../../../../assets/tshirtinfo.svg'
import QRCodeStyling from 'qr-code-styling'
import { ReactComponent as MySVG } from '../../../../../assets/fsc.svg'
import { ReactComponent as MySVG2 } from '../../../../../assets/logolar-02.svg'
import { ReactComponent as MySVG3 } from '../../../../../assets/logolar-03.svg'
import { ReactComponent as MySVG4 } from '../../../../../assets/logolar-04.svg'
import { ReactComponent as MySVG5 } from '../../../../../assets/logolar-05.svg'
import { ReactComponent as MySVG6 } from '../../../../../assets/Varlık1.svg'
import { ReactComponent as ALARM } from '../../../../../assets/alarm (1).svg'
import { ReactComponent as NearQR } from '../../../../../assets/zarahome/zaranear2.svg'
import { ReactComponent as MySVG7 } from '../../../../../assets/pricetopsvg/pricehomebathroom.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/pricetopsvg/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/pricetopsvg/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/pricetopsvg/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/pricetopsvg/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/pricetopsvg/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/pricetopsvg/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'

import { ReactComponent as MySVG18 } from '../../../../../assets/altbestlogo.svg'
import { ReactComponent as MyLogoHarman } from '../../../../../assets/altlogoharman.svg'
import { BASE_URL2 } from 'config/axios'
import { ReactComponent as ZaraLogoNewFullfill } from '../../../../../assets/zarahome/fscfullfilnew.svg'
import { ReactComponent as EacNew } from '../../../../../assets/zarahome/eacnew.svg'

import { ReactComponent as MySVG19 } from '../../../../../assets/talla.svg'
import { ReactComponent as MySVG20 } from '../../../../../assets/usuk.svg'
import { ReactComponent as MySVG249 } from '../../../../../assets/justus.svg'
import { ReactComponent as MySVG250 } from '../../../../../assets/justuk.svg'
import { ReactComponent as MySVG21 } from '../../../../../assets/usamexuk.svg'
import { ReactComponent as MySVG22 } from '../../../../../assets/lineline.svg'
import { ReactComponent as MySVG2900 } from '../../../../../assets/RDOLAR.svg'
import { ReactComponent as MySVGTry } from '../../../../../assets/55110.svg'
import { useAuth } from 'store/client/authStore'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg';
import { ReactComponent as BlackDenim } from '../../../../../assets/black-denimwear.svg' // SVG'yi React bileşeni olarak içe aktarma

import { ReactComponent as ZaraFscrr } from '../../../../../assets/zarahome/newfscrr.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/zarahome/newfsctm.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/zarahome/newfsctmpaper.svg'
import { ReactComponent as ZaraGeneralBack } from '../../../../../assets/zarahome/generalback.svg'
import { ReactComponent as ALARMHOME } from '../../../../../assets/zarahome/ALARMHOME.svg'
import { ReactComponent as PaperComponent } from '../../../../../assets/zarahome/pap.svg'

import { ReactComponent as Ceramic } from '../../../../../assets/zarahome/ceramic.svg'
import { ReactComponent as Zar4lu } from '../../../../../assets/zarahome/4luzara.svg'
import {ReactComponent as Housedecouttenopillow} from '../../../../../assets/zarahome/housedecouttenopillow.svg'
import {ReactComponent as Label12Card} from '../../../../../assets/zarahome/Label125.svg'
import { useAutoFit } from "./useAutoFit";

import EtiketBlok from './etiketblok'
import { ReactComponent as Path689 } from '../../../../../assets/zarahome/path689.svg'

import { ReactComponent as Varlık3New } from '../../../../../assets/zarahome/Varlık3new.svg'

import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { LiaCircleSolid } from 'react-icons/lia'
import { BiSolidCircle } from 'react-icons/bi'
import DynamicShrinkText from './DynamicShrinkText'
import DynamicTextLeftt from './DynamicShrinkLefft'
import QRCodeComponent from './qrcodecomponent'
import RenderIndoItems from './RenderIndoItems'
import RenderIndoItemsCM from './RenderIndoItemsCM'
import DynamicTextKids from './DynamicTextKids'
import RenderIndoItemsKids from './RenderIndoItemsKıds'
import { transform } from 'lodash'


export default function Label12({
  sizeData,
  renderShape,
  Path1,
  selectColor = 0,
  barcodeValue,
  qrcodeValue,
  data,
  indo,
  inx,
  szrgrp,
  integerpart3,
  currencysymbol3,
  integerpart4,
  currencysymbol4,
  decimalpart3,
  decimalpart4,
  rifd,
  SouthAmerica,
  harmacn,
  cardType,
  homeProducts,
  productDescriptions,
  processedDescriptions,
  x,
  y,

}) {
  const divRef = useRef(null)
  const textRef = useRef(null)
  const [scaleX, setScaleX] = useState(1)
  const department = data.department
  const barcodeRef = useRef(null);
  const [modifiedSvgText, setModifiedSvgText] = useState("");
  const [topValue, settopValue] = useState(16) 
  const [leftValue, setleftValue] = useState(97.9)  
  const [isLeather, setisLeather] = useState(false)  
const [texttt, setTexttt] = useState("")
const symbol = data.zaraHomeLabel12[0]?.symbol
console.log("realdatabadman",sizeData)
console.log("symbolll",symbol)
const { ref, scale } = useAutoFit({ maxHeight: 120 }); // 120px sınırın

  // Bölmek için "/" karakterini kullan
  const selectedFscType = data.company?.fsctype;

  const leatherTypes = [
    "BUFFALO FURSKIN", "BUFFALO LEATHER", "CALF FURSKIN", "COLT LEATHER",
    "COW FURSKIN", "GOAT LEATHER", "HORSE LEATHER", "LAMB FURSKIN",
    "LAMBSKIN", "PIG FURSKIN", "PIG LEATHER", "RABBIT LEATHER",
    "SHEEP FURSKIN", "SHEEP LEATHER"
  ]

  const [brand, category, subCategory] = department ? department.split(' / ') : ['', '', '']

  const filteredIndo = indo.filter((item) => item.amount !== '')
  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  
  // FSC Components - ReactComponent import'ları kullanılıyor (src path'leri kaldırıldı)
  const FSC_COMPONENTS = {
    fscrr: { 
      component: ZaraLogoNewFullfill, 
      width: "5.6mm", 
      height: "auto"
    },
    fsctm: { 
      component: ZaraLogoNewFullfill, 
      width: "5.6mm", 
      height: "auto"
    },
    fsctmpaper: { 
      component: ZaraLogoNewFullfill, 
      width: "5.6mm", 
      height: "auto"
    },
  };

  // selectedFscType kontrolü - eğer undefined ise veya geçersiz ise, ilk geçerli component'i kullan
  const validFscType = selectedFscType && FSC_COMPONENTS[selectedFscType] 
    ? selectedFscType 
    : null;
  const SelectedComponent = validFscType ? FSC_COMPONENTS[validFscType] : null;
  
  // Debug: SVG component'lerinin yüklenip yüklenmediğini kontrol et
  useEffect(() => {
    console.log("dsadsads",data.company)
    if (process.env.NODE_ENV === 'development') {
      if (!selectedFscType) {
        console.warn("⚠️ FSC Type bulunamadı:", {
          dataCompany: data.company,
          fsctype: data.company?.fsctype,
          availableTypes: Object.keys(FSC_COMPONENTS),
          "💡 İpucu": "Backend'den gelen data.company.fsctype değerini kontrol edin"
        });
      }
      console.log("🔍 FSC Debug:", {
        selectedFscType,
        validFscType,
        SelectedComponent: SelectedComponent ? "✅ Bulundu" : "❌ Bulunamadı",
        ZaraFscrr: typeof ZaraFscrr,
        ZaraFsctm: typeof ZaraFsctm,
        ZaraFsctmpaper: typeof ZaraFsctmpaper,
        dataCompany: data.company
      });
    }
  }, [selectedFscType, data.company, validFscType, SelectedComponent]);

  useEffect(() => {
    if (category) {
      setCurrentShape(category)
    }
  }, [category])

  const handleSvgGenerated = (svgText) => {
    setModifiedSvgText(svgText);
  };
  // Optimized function using pre-cached descriptions
  function getProductTextById(id) {
    return processedDescriptions[id]?.fullText || "";
  }
  
  useEffect(() => {

    // Belirtilen seçiciyle DOM öğesini yakalama
    const textElement = document.querySelector(
      '#root > div.min-h-screen.font-poppins > div > div:nth-child(3) > div:nth-child(1) > div > div > div > div:nth-child(3) > div:nth-child(3) > div.printable > div > div > div > div.tracking-\\[\\.02rem\\] > svg > g > text'
    );

    if (textElement) {
      // Margin top değerini güncelle
      //textElement.style.marginTop = '-10px ';
    } else {
    }
  }, []); // Sadece bileşen yüklendiğinde bir kez çalışacak




  const renderSVG = (integer3, decimal3, integer4, decimal4) => {
    console.log("Values received:", { integer3, decimal3, integer4, decimal4 });
    console.log("SUBCATEGORYY",subCategory);
    // Değerleri stringe çevirip kontrol ediyoruz
    const isInteger3Valid = String(integer3).trim() !== '';
    const isDecimal3Valid = String(decimal3).trim() !== '';
    const isInteger4Valid = String(integer4).trim() !== '';
    const isDecimal4Valid = String(decimal4).trim() !== '';
  if(SouthAmerica)
  {
    return <MySVG2900 width="23.256mm" height="14.496mm" />;
    

  }
  else{
    switch (true) {
      case isInteger3Valid && isDecimal3Valid && isInteger4Valid && isDecimal4Valid:
        console.log("Case 1: All values are present (integer3, decimal3, integer4, decimal4)");
        return <MySVG20 width="21.256mm" height="14.496mm" />;
      case isInteger3Valid && isDecimal3Valid && !isInteger4Valid :
        console.log("Case 2: Only integer3 and decimal3 are present, integer4 and decimal4 are missing");
        return <MySVG249 width="21.256mm" height="14.496mm" />;
      case isInteger4Valid && isDecimal4Valid && !isInteger3Valid:
        console.log("Case 3: Only integer4 and decimal4 are present, integer3 and decimal3 are missing");
        return <MySVG250 width="21.256mm" height="14.496mm" />;
      default:
        console.log("Default Case: None of the conditions are met", { integer3, decimal3, integer4, decimal4 });
        return null; // Hiçbir koşul sağlanmazsa hiçbir şey döndürme
    }
  }
  

  };
 /* 
  <div style={{position:"absolute",left:12,top:-2}}>
  <MySVGTry style={{width:"55.2mm",height:"110.2mm"}}/>

  </div>
  */


  useEffect(() => {
    const adjustScale = () => {
      if (divRef.current && textRef.current) {
        const containerWidth = divRef.current.offsetWidth
        const textWidth = textRef.current.offsetWidth

        if (textWidth > containerWidth) {
          setScaleX(containerWidth / textWidth)
        } else {
          setScaleX(1)
        }
      }
    }

    adjustScale()
    window.addEventListener('resize', adjustScale) // Dinamik ekran boyutu için
    return () => window.removeEventListener('resize', adjustScale)
  }, [filteredIndo, inx])

  

  const valueBasedOnInx = indexedIndo[inx]

  const [currentShape, setCurrentShape] = useState(null)

  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'
  let shape
  
  const isBlackLabel = referance?.backgroundColor === 'B'


  return (
    <div>
             <div>
          <div>
          <Label12Card width="115mm" height="95.177mm" style={{marginBottom:10}}></Label12Card>
          <div style={{ position: 'absolute', bottom: 193, right: -35,width:"165px"}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
               
                  <p className="arial-regular" style={{ fontSize: '4.5pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo.split('/').join(' / ')} / ${data.zaraHomeLabel12[selectColor].colorCode} / ${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>

          <div style={{position:"absolute",top:-1.5,left:128}}>
          <div style={{position:"relative",width:"52mm",height:"90mm",marginTop:-1}}>
 
          <div style={{ position: 'absolute', bottom: -13.4, right: 12.4,display:"none" }}>
           {subCategory==="KIDS" || category==="Kids" ? <PaperComponent width="4.636mm" height="6mm" /> : null}
          </div>
              <div style={{ position: 'absolute', bottom: -64.4, right: -118.4,transform: "scale(2.67)" }}>
                <QRCodeComponent  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
              <div style={{ position: 'absolute', bottom: -12.5, right: -20.1,transform: "scale(1.3)"}}>
              {SelectedComponent && SelectedComponent.component ? (
                (() => {
                  const Component = SelectedComponent.component;
                  // Component'in bir React component olup olmadığını kontrol et
                  if (Component && (typeof Component === 'function' || (typeof Component === 'object' && Component.$$typeof))) {
                    try {
                      return (
                        <Component
                          width={SelectedComponent.width}
                          height={SelectedComponent.height}
                        />
                      );
                    } catch (error) {
                      console.error("❌ SVG Component render hatası:", error);
                      return null;
                    }
                  }
                  return null;
                })()
              ) : null}
    
    </div>

    <div ref={barcodeRef} style={{ position: 'absolute', bottom: 55.4, right: 114.5,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.8}
                  height={23}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={10} // 7pt yaklaşık olarak 9px
                  font="Arial-Narrow"
                />
              </div>

         

              <div style={{position:"absolute",top:8.8,height:29,left:129,width:"165px",display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                  <p className="arial-bold"
                    style={{
                      fontSize: "7.8pt",
                      lineHeight: "19.7px",
                      letterSpacing: "0.2px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                    <p className="arial-bold"
                    style={{
                      fontSize: "8.3pt",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:"2.55px",
                      marginTop:"-0.66px",

                    }}>
                      {subCategory==="KIDS" || category==="Kids" ? "-" : "/"}
                    </p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "7.8pt",
                      lineHeight: "19.7px",
                      letterSpacing: "0.2px",
                      color: "black",
                      marginLeft:"2.55px",
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>

                  <div style={{position:"absolute",top:10.9,height:29,left:-165,width:"165px",display:"flex",justifyContent:"flex-end",alignItems:"center",letterSpacing:"-0.1px"}}>
                    
                  <span className="pdf-force" style={{fontSize:"6.2pt",color:"black",fontWeight:400}}>CONT. {sizeData.pack === "Pack 2" 
          ? "2" 
          : sizeData.pack === "Pack 3" 
          ? "3" 
          : "1"} PIEZA | PIECE | PIÈCE </span>
                    </div>
                  <div className="text-[3.7pt]  text-justify pdf-force">

  

              
              </div>
          </div>
       
          </div>
          <div style={{position:"absolute",top:-1.5,left:332}}>
          <div className="flex items-center h-full" style={{position:"absolute", top:154, left:-309,height:60,transform: "scale(1.3)"}}>
              <div className="flex items-center h-full ">
           <div className="flex items-start justify-between px-[6mm] w-full" >
           <div
  className="w-[21.3mm] h-[14mm] grid grid-cols-5 grid-rows-3 place-items-center items-start gap-x-0 gap-y-[-1px]"
 
>
  {/* Üst sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}.svg`}
    alt="sembol icon"
    style={{ width: 13, height: 14, padding: 0.4 ,marginLeft:1.4,marginTop:-0.6}}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}.svg`}
    alt="sembol icon"
    style={{ width: 14, height: 15, padding: 0.4,marginTop:-1,marginLeft:3.8,opacity:1 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}.svg`}
    alt="sembol icon"
    style={{ width: 10.5, height: 10.5, padding: 0.4,marginLeft:7,marginTop:1.8 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}.svg`}
    alt="sembol icon"
    style={{ width: 13.5, height: 11.3, padding: 0.4,marginTop:1.1,marginLeft:9}}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}.svg`}
    alt="sembol icon"
    style={{ width: 11.5, height: 11.5, padding: 0.4 ,marginLeft:12,marginTop:1.1}}
  />

  {/* Orta sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_1.svg`}
    alt="sembol icon"
    style={{  width: 15.3, height: 15.3, padding: 0.4 ,marginLeft:1.8,marginTop:-1.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_1.svg`}
    alt="sembol icon"
    style={{ width: 15, height: 15, padding: 0.4 ,marginLeft:4,marginTop:-1.7 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_1.svg`}
    alt="sembol icon"
    style={{  width: 15.9, height: 10, padding: 0.4 ,marginLeft:5.4,marginTop:0.3}}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_1.svg`}
    alt="sembol icon"
    style={{  width: 12, height: 12, padding: 0.4 ,marginLeft:9.2,marginTop:-0.2 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_1.svg`}
    alt="sembol icon"
    style={{ width: 10.5, height: 11.5, padding: 0.4 ,marginLeft:12,}}
  />

  {/* Alt sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_2.svg`}
    alt="sembol icon"
    style={{ width: 15, height: 15, padding: 0.4 ,marginLeft:1.7,marginTop:-1.9 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_2.svg`}
    alt="sembol icon"
    style={{ width: 14, height: 14, padding: 0.4 ,marginLeft:4.5,marginTop:-1 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_2.svg`}
    alt="sembol icon"
    style={{ width: 10.5, height: 10.5, padding: 0.4 ,marginLeft:6.8,marginTop:0.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_2.svg`}
    alt="sembol icon"
    style={{ width: 14.9, height: 11.2, padding: 0.4 ,marginLeft:9.7,marginTop:0.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_2.svg`}
    alt="sembol icon"
    style={{ width: 12.2, height: 12.2, padding: 0.4 ,marginLeft:12,marginTop:-0.3 }}
  />
</div>

        
          </div>
        </div>
          </div>
      <EtiketBlok selectColor={selectColor} sizeData={sizeData} data={data} getProductTextById={getProductTextById }></EtiketBlok>
          </div>

          <div
  style={{
    position: "absolute",
    top: "148.4px",
    height: "29px",
    right: "-179.4px",
    width: "248px",
    letterSpacing: "-0.5px",
    lineHeight: "5px",
    textAlign: "justify",
    wordBreak: "break-word",
    wordSpacing: "-0.3px",
    WebkitFontSmoothing: "antialiased",
    display:"none",
  }}
>
          <span className="pdf-force" style={{fontSize:"5.5pt",color:"black",fontWeight:400}}>ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516 ITX USA LLC. ZARA HOME BRASIL P. L. LTDA. CNPJ:13.144.185/0001-50 MODA HOME S.A.S. SIC 900.495.729 （株）ITXジャパン (0120-914-075) ITX Canada Ltd. 아이티엑스코리아 주식회사, 서울특별시 강남구 영동대로 511 (삼성동) 20층 2002호 080-500-6445. RUC 80089402-2. MA-MAROC: Sté RTW MAROC IF: 1642262. IMPORTADO POR ZARA HOME MEXICO, S.A. DE C.V. PONIENTE 146 NO. 730 COLONIA INDUSTRIAL VALLEJO ALCALDIA AZCAPOTZALCO, C.P. 02300, CIUDAD DE MEXICO, RFC: ZHM040609ES5.</span>

</div>


          </div>
        </div>
        <NearQR width="4.53mm" height="12.9mm" style={{position:"absolute",bottom:77 ,right:-153.5,opacity:1}}/>
        <Varlık3New width="420mm" height="297mm" style={{position:"absolute",top:-356 ,left:-577,opacity:0.4,display:"none"}}/>
        <EacNew width="6mm" height="6mm" style={{position:"absolute",bottom:80.5 ,right:-95,opacity:1}}/>

    </div>
  )
}
